// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import "./clockinout.css";
// import { formatDateTimeZone } from "../../../../UTC2Local";
// import { changeTimer } from "../../../../app/reducers/timerSlice";

// const MyTime = ({ clockInTime, checkedIn, currentTime }) => {
// 	const dispatch = useDispatch();
// 	const [timeSpent, setTimeSpent] = useState("00:00:00");
// 	const percentage = React.useRef(0);
// 	const valueToAdd = React.useRef(0);

// 	useEffect(() => {
// 		if (!checkedIn) {
// 			setTimeSpent("00:00:00");
// 		} else {
// 			setTimeSpent(handleTimer());
// 		}
// 	}, [checkedIn]);

// 	const handleTimer = () => {
// 		let startDate = new Date(formatDateTimeZone(clockInTime));
// 		let currentDate = new Date(formatDateTimeZone(currentTime));
// 		let timeDifference = currentDate - startDate + valueToAdd.current;

// 		valueToAdd.current += 1000;
// 		dispatch(changeTimer(valueToAdd.current));

// 		// Calculate hours and minutes
// 		const hours =
// 			timeDifference < 0
// 				? Math.ceil(timeDifference / 3600000)
// 				: Math.floor(timeDifference / 3600000);
// 		const minutes =
// 			timeDifference < 0
// 				? Math.ceil((timeDifference % 3600000) / 60000)
// 				: Math.floor((timeDifference % 3600000) / 60000);
// 		const seconds =
// 			timeDifference < 0
// 				? Math.ceil((timeDifference % 60000) / 1000)
// 				: Math.floor((timeDifference % 60000) / 1000);

// 		// Format hours and minutes with leading zeros
// 		const formattedHours = hours.toString().padStart(2, "0");
// 		const formattedMinutes = minutes.toString().padStart(2, "0");
// 		const formattedSeconds = seconds.toString().padStart(2, "0");

// 		percentage.current = formattedSeconds;

// 		return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
// 	};

// 	useEffect(() => {
// 		if (clockInTime != null) setTimeSpent(handleTimer());
// 	}, [clockInTime, currentTime]);
// 	useEffect(() => {
// 		const startTimer = setInterval(() => {
// 			if (clockInTime != null) {
// 				setTimeSpent(handleTimer());
// 			} else {
// 				clearInterval(startTimer);
// 				setTimeSpent(null);
// 			}
// 		}, 1000);

// 		// Clear the interval when the component unmounts
// 		return () => {
// 			clearInterval(startTimer);
// 		};
// 	}, [clockInTime]);

// 	return <div>{timeSpent && <div>{timeSpent}</div>}</div>;
// };

// export default MyTime;

import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { formatDateTimeZone } from "../../../../UTC2Local";
import { changeTimer } from "../../../../app/reducers/timerSlice";

// interface Props {
//   clockInTime: string | null
//   checkedIn: boolean
// }

export default function MyTime({ clockInTime, checkedIn }) {
	const dispatch = useDispatch();
	const [timeSpent, setTimeSpent] = useState("00:00:00");
	// store the clock‐in timestamp once
	const startTsRef = useRef(null);

	// whenever we check in or out, reset startTsRef
	useEffect(() => {
		if (checkedIn && clockInTime) {
			// parse the incoming time into a JS timestamp
			startTsRef.current = new Date(
				formatDateTimeZone(clockInTime)
			).getTime();
		} else {
			startTsRef.current = null;
			setTimeSpent("00:00:00");
			dispatch(changeTimer(0));
		}
	}, [checkedIn, clockInTime, dispatch]);

	// interval that updates every second
	useEffect(() => {
		if (startTsRef.current == null) return;

		const update = () => {
			const now = Date.now();
			const diff = now - startTsRef.current;
			dispatch(changeTimer(diff));
			setTimeSpent(formatMs(diff));
		};

		// run immediately once, then every 1s
		update();
		const timerId = setInterval(update, 1000);
		return () => clearInterval(timerId);
	}, [dispatch]);

	// helper to format ms → "HH:MM:SS"
	function formatMs(ms) {
		const totalSec = Math.max(Math.floor(ms / 1000), 0);
		const hrs = Math.floor(totalSec / 3600);
		const mins = Math.floor((totalSec % 3600) / 60);
		const secs = totalSec % 60;
		return [hrs, mins, secs].map((n) => String(n).padStart(2, "0")).join(":");
	}

	return <div>{timeSpent}</div>;
}
